<template>
    <v-dialog v-model="show" max-width="500">
        <v-card>
            <v-card-title class="headline primary primarytext--text">
                {{name}}
                <v-btn icon @click="show = false" class="ml-auto"><v-icon color="primarytext">mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
                <v-row class="mt-4">
                    <v-col cols="auto">
                        <v-auto-img
                            :src="imagekey || '/assets/img/profile_avatar_man.jpg'"
                            :key="imagekey"
                            style="border-radius: 4px"
                            width=200
                        />
                    </v-col>
                    <v-col>
                        <h3>{{name}}</h3>
                        <p v-if="$store.state.settings && $store.state.settings.wbshowinstructorphonenumber">{{phoneNumber}}</p>
                        <p v-safe-html="description"></p>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <zoezi-button :text="$translate('Close')" @click="show = false" />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {getName} from '../util.js'
export default {
    name: 'zoezi-staff-info-dialog',

    zoezi: {
        title: "Staff info dialog",
        icon: "mdi-account",
    },

    props: ['value', 'staffId'],

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.show = value;
            }
        },
        staffId: {
            immediate: true,
            handler(staffId) {
                if (staffId) {
                    this.$api.get('/api/public/resource/get', {id: staffId}).then(staff => {
                        this.fetchedStaff = staff;
                    })
                }
            }
        },
        show(show) {
            if (show != this.value) {
                this.$emit('input', show);
            }
        }
    },

    computed: {
        description() {
            return this.fetchedStaff?.description;
        },
        name() {
            return this.fetchedStaff && getName(this.fetchedStaff);
        },
        imagekey() {
            return this.fetchedStaff?.imagekey;
        },
        phoneNumber() {
            return this.fetchedStaff?.phone;
        }
    },

    data: () => ({
        show: false,
        fetchedStaff: null
    }),
}
</script>
